<template>
  <div>
    <loading-page
      :show-loading-page="showLoadingPage"
      :loading-message="loadingMessage"
    />
  </div>
</template>
<script>
import LoadingPage from '../dashboard/LoadingPage.vue';
import axios from 'src/app-axios';

export default {
    name: 'ClearLocalStorage',
    components: {
      'loading-page': LoadingPage,
    },

    data () {
      return {
        showLoadingPage: false,
        loadingMessage: '',
      };
    },
    mounted () {
      this.showLoadingPage = true;
      this.loadingMessage = 'Logging Off...';
      setTimeout(() => {
       this.clearStorage();
      }, 2000);
    },
    methods: {
      async clearStorage () {
        axios.post('api/logout');
        this.$store.dispatch('clearStorage').then(() => {
            this.$router.push({ name: 'Login' });
        }).catch(() => {
            this.$router.push({ name: 'Login' });
        });
      },
    },
};
</script>
